import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Checkbox } from "../ui/checkbox";
import { MapPin } from "lucide-react";
import { SEZ, Field, Sel } from "./fields";
import { SI_NO } from "../../lib/options";
import { EnteSearch, GoogleIndirizzo } from "./AddressSearch";

export const Logistica = ({ title, data, set, setAll, prefix, onGeo, saveAddr, setSaveAddr }) => {
  const pickEnte = (loc) => setAll({
    indirizzo: loc.indirizzo || "", citta: loc.citta || "", reparto_citofono: loc.reparto_citofono || "",
    piano: loc.piano || "", scala: loc.scala || "", ascensore: loc.ascensore || "",
  });
  const pickPlace = (d, s) => {
    if (!d) return setAll((prev) => ({ ...prev, indirizzo: s.text }));
    setAll((prev) => ({ ...prev, indirizzo: d.indirizzo || s.text, citta: d.citta || prev.citta }));
    if (d.lat != null && d.lng != null && onGeo) onGeo({ lat: d.lat, lng: d.lng });
  };
  return (
    <SEZ icon={MapPin} title={title}>
      <EnteSearch prefix={prefix} onPick={pickEnte} />
      <GoogleIndirizzo prefix={prefix} value={data.indirizzo} onChange={(v) => set("indirizzo", v)} onPlace={pickPlace} />
      <div className="md:col-span-2">
        <Label className="nx-label">Indirizzo Visualizzato</Label>
        <Input data-testid={`${prefix}-citta`} value={data.citta} onChange={(e) => set("citta", e.target.value)} className="mt-1.5"
          placeholder="Es. solo la città — visibile ai partner prima dell'assegnazione" />
        <p className="text-xs text-slate-400 mt-1">Modificabile: scegli cosa mostrare ai partner (es. solo il comune) finché la corsa non è assegnata.</p>
      </div>
      <Field label="Reparto / Citofono" value={data.reparto_citofono} onChange={(v) => set("reparto_citofono", v)} testid={`${prefix}-reparto`} />
      <Field label="Piano" value={data.piano} onChange={(v) => set("piano", v)} testid={`${prefix}-piano`} />
      <Field label="Scala" value={data.scala} onChange={(v) => set("scala", v)} testid={`${prefix}-scala`} />
      <Sel label="Ascensore" value={data.ascensore} onChange={(v) => set("ascensore", v)} options={SI_NO} testid={`${prefix}-ascensore`} />
      <label className="md:col-span-2 flex items-center gap-2 mt-1 cursor-pointer select-none">
        <Checkbox data-testid={`${prefix}-save-address`} checked={saveAddr} onCheckedChange={(v) => setSaveAddr(!!v)} />
        <span className="text-sm text-slate-600">Salva questo indirizzo nell'archivio interno (riutilizzabile in future richieste)</span>
      </label>
    </SEZ>
  );
};
